import Products from "../Products";

const Releases = () => {
  const title = "Lançamentos";

  return <Products title={title} lancamento params={{}} />;
};

export default Releases;
